import React, { Component } from "react";
import { connect } from "react-redux";
import Loadable from "react-loadable";
import LoadableLoading from "~/components/mobile/molecules/LoadingPage";
import { withTitle } from "~/components/common/molecules/TitleHelmet";

import { partnerInfo } from "~/configs/partnerDetails";
import { get, find } from "lodash";

const info = get(partnerInfo, "info");
const hospitalName = find(info, { key: "name" });

const PrivacyPolicyPageMobile = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "mobile" */ "~/components/desktop/pages/PrivacyPolicy"
    ),
  loading: LoadableLoading
});
const PrivacyPolicyPageDesktop = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "desktop" */ "~/components/desktop/pages/PrivacyPolicy"
    ),
  loading: LoadableLoading
});

class DetectPrivacyPolicy extends Component {
  render() {
    const { device } = this.props;
    return (
      <React.Fragment>
        {device === "mobile" ? (
          <PrivacyPolicyPageMobile />
        ) : (
          <PrivacyPolicyPageDesktop />
        )}
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => {
  const {
    global: {
      device: { type }
    }
  } = state;
  return {
    device: type
  };
};

const PrivacyPolicyHelmet = withTitle({
  component: DetectPrivacyPolicy,
  title: `${hospitalName.value} | Chính sách bảo mật`
});

export default connect(mapStateToProps)(PrivacyPolicyHelmet);
